import { InfoCircleIcon } from '@/componentsV1/Icons/InfoCircle';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Flex,
  Box,
} from '@chakra-ui/react';
import {
  checkForInvalidVariables,
  checkForInvalidVariablesInSubjectAndBody,
} from './commonHelpers';

export const getInvalidVariableAlertConfig = ({
  variablesListArr,
  isBodySubject = true,
  key = '',
  wrapperProps = {},
}) => {
  return {
    type: 'custom',
    Field: ({ formik }) => {
      const { values } = formik;
      let isInvalidVariablesFound;
      if (isBodySubject) {
        const { subject, body } = values;
        const subjectVariablesListArr = variablesListArr.filter(
          (variable) => variable !== 'sender.email_signature'
        );

        isInvalidVariablesFound = checkForInvalidVariablesInSubjectAndBody({
          variablesListArr,
          body,
          subject,
          variablesListSubject: subjectVariablesListArr,
        });
      } else if (key) {
        const { [key]: body } = values;
        isInvalidVariablesFound = checkForInvalidVariables({
          variablesListArr,
          content: body,
        });
      }
      const alertTitle = 'Empty variables detected';
      const alertDesc =
        'The variables marked in red do not have any data. Remove them to continue';

      if (!isInvalidVariablesFound) return null;

      return (
        <Alert
          status="warning"
          bg="#FFF2CC"
          borderRadius="sm"
          border="1px solid"
          borderColor="ats-border-color"
          justifyContent="space-between"
          alignItems="center"
          my="10px"
          p={0}
          overflow="unset"
          id="invalid-variables-alert"
          // Please don’t remove this className — it’s required by CalendarInvites/container.tsx and EmailInvites/index.tsx -- have dependencies there.
          className="empty-variable-alert-container"
          {...wrapperProps}
        >
          <Flex p="16px" gap="12px" alignItems="center" justifyContent="start">
            <InfoCircleIcon />
            <Box>
              <AlertTitle fontSize={'14px'} fontWeight={700}>
                {alertTitle}
              </AlertTitle>
              <AlertDescription fontSize={'12px'} lineHeight="20px">
                {alertDesc}
              </AlertDescription>
            </Box>
          </Flex>
        </Alert>
      );
    },
  };
};
